import api from '../api';
import { toast } from 'react-toastify';
import messageTypes from '../../constants/MessagesTypes';
import { addCompanyIdToRequest } from '../../utils/companyContext';

export async function getProductsForSale(searchTerm = '') {
  try {
    const params = addCompanyIdToRequest({
      stringSearch: searchTerm
    }, 'GET');
    
    const response = await api.get(`/api/sale/products`, {
      params: params,
      headers: {
        auth: true
      },
    });
    return response.data.data || [];
  } catch (error) {
    toast.error(messageTypes.ERROR_LOAD || 'Erro ao carregar produtos');
    return [];
  }
}

export async function createSale(saleData) {
  try {
    const dataWithCompany = addCompanyIdToRequest(saleData, 'POST');
    
    const response = await api.post(`/api/sale/new`, dataWithCompany, {
      headers: {
        'Content-Type': 'application/json',
        auth: true
      },
    });
    return response;
  } catch (error) {
    toast.error(error.response?.data?.message || 'Erro ao realizar venda');
    throw error;
  }
}

export async function getSales(data) {
  try {
    const params = addCompanyIdToRequest(data || {}, 'GET');
    
    const response = await api.get(`/api/sale`, {
      params: params,
      headers: {
        auth: true
      },
    });
    return response;
  } catch (error) {
    toast.error(messageTypes.ERROR_LOAD || 'Erro ao carregar vendas');
    return { data: { data: [], total: 0 } };
  }
}

export async function getSale(id) {
  try {
    const response = await api.get(`/api/sale/${id}/find`, {
      headers: {
        auth: true
      },
    });
    return response.data.data || {};
  } catch (error) {
    toast.error(messageTypes.ERROR_LOAD || 'Erro ao carregar venda');
    throw error;
  }
}

export function deleteSale(id, restoreStock = true) {
  // Usar query parameter para compatibilidade com método DELETE
  const url = `/api/sale/delete/${id}?restoreStock=${restoreStock}`;
  
  return api.delete(url, {
    headers: {
      auth: true
    },
  }).catch((error) => {
    toast.error(error.response?.data?.message || 'Erro ao cancelar venda');
    throw error;
  });
}




